import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';
import './About.css';

function About() {
  const revealRef = useScrollReveal();

  return (
    <section className="about reveal" id="about" ref={revealRef}>
      <div className="container">
        <span className="section-label">{"// About Me"}</span>
        <div className="about-grid">
          <div className="about-image">
            <img src="/images/topPM.jpeg" alt="Stanley Okafor" className="profile-photo" />
          </div>
          <div className="about-content">
            <h2 className="section-title">
              More than just<br />
              <span className="highlight">lines of code</span>
            </h2>
            <p className="about-text">
              I'm Stanley — a Nigerian-Canadian based in Mississauga, studying
              Computer Programming at George Brown College. I balance factory
              floors and code editors, and I'm always looking to get better at
              both.
            </p>
            <p className="about-text">
              Big on football, sports, and coaching. Raised on afrobeats,
              recently fell into R&B. Self-improvement is the goal — on and
              off the screen.
            </p>
          </div>

          <div className="about-currently">
            <h3 className="currently-title mono">Currently</h3>
            <div className="currently-item">
              <span className="currently-label">Building</span>
              <span className="currently-value">MERN e-commerce store</span>
            </div>
            <div className="currently-item">
              <span className="currently-label">Learning</span>
              <span className="currently-value">TypeScript, Docker, Microservices</span>
            </div>
            <div className="currently-item">
              <span className="currently-label">Listening to</span>
              <span className="currently-value">Afrobeats & R&B</span>
            </div>
            <div className="currently-item">
              <span className="currently-label">Watching</span>
              <span className="currently-value">Premier League</span>
            </div>
            <div className="currently-item">
              <span className="currently-label">Reading</span>
              <span className="currently-value">Atomic Habits</span>
            </div>
            <div className="currently-item">
              <span className="currently-label">Motto</span>
              <span className="currently-value">"Get 1% better every day"</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
